<template>
	<modal @close="close">
		<div class="review">
			<div class="title">Ordre overblik</div>

			<div class="sections">
				<div class="section" v-for="section in sections" :key="section.title">
					<div class="title" v-text="section.title"/>

					<div class="fields">
						<div class="field" v-for="(value, key) in section.fields" :key="key">
							<div class="key" v-text="`${key}:`"/>&nbsp;
							<div class="value" v-text="value"/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</modal>
</template>

<script>
import modal from "@/components/modal.vue";

export default {
	components: {modal},
	computed: {
		sections: (t) => t.$store.getters["order/payload"].sections
	},
	methods: {
		close() {
			this.$emit("close");
		}
	}
};
</script>

<style lang="scss" scoped>
.review {
	padding: 1em 0;
	display: flex;
	align-items: center;
	flex-direction: column;

	> .title {
		font-weight: bold;
		font-size: 1.4em;
		margin-bottom: 2em;
	}

	@include res(mobile) {
		padding: 0;
	}

	.sections {
		color: #22313A;

		.section {
			margin-bottom: 2em;

			.title {
				font-weight: 600;
				font-size: 1.15em;
				border-bottom: 1px solid $grey2;
				margin-bottom: 0.5em;
				padding-bottom: 0.25em;
			}

			.fields {
				display: flex;
				flex-wrap: wrap;
				font-size: 14px;

				.field {
					width: 50%;
					display: flex;
					margin-bottom: 0.5em;

					@include res(mobile) {
						width: 100%;
					}

					.key {
						font-weight: 500;
					}
				}
			}
		}
	}
}
</style>
